import {
    getLocalizedString,
    OwaTimeformatLocalizedStringResourceId,
} from 'owa-timeformat/lib/localization/getLocalizedString';

import DayOfWeekIndexType from 'owa-service/lib/contract/DayOfWeekIndexType';

export default function getLocalizedDayOfWeekIndex(dayOfWeekIndex: DayOfWeekIndexType): string {
    return getLocalizedString(('calendarDayOfWeekIndex_' +
        dayOfWeekIndex) as OwaTimeformatLocalizedStringResourceId);
}
